<ng-template #texto let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-max="max" let-span="span">
  <div class="m193d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido">
    <app-ui-input [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, maxLength: max }"></app-ui-input>
  </div>
</ng-template>

<ng-template #importe let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-span="span">
  <div class="m193d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido">
    <app-ui-input [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: '0.01', inputmode: 'decimal' }"></app-ui-input>
  </div>
</ng-template>

<ng-template #entero let-ruta="ruta" let-etiqueta="etiqueta" let-span="span">
  <div class="m193d-field" [style.grid-column]="'span ' + (span || 3)">
    <app-ui-input [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: '1', min: 0, inputmode: 'numeric' }"></app-ui-input>
  </div>
</ng-template>

<ng-template #seleccion let-ruta="ruta" let-etiqueta="etiqueta" let-opciones="opciones" let-requerido="requerido"
  let-placeholder="placeholder" let-span="span">
  <div class="m193d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido">
    <app-select [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, options: opciones, placeholder: placeholder, autoSelectSingle: !!requerido }"></app-select>
  </div>
</ng-template>

<ng-template #sino let-ruta="ruta" let-etiqueta="etiqueta" let-span="span">
  <div class="m193d-field" [style.grid-column]="'span ' + (span || 3)">
    <app-select [attr.id]="ruta" [ngModel]="get(ruta)" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, options: sinoOptions }"></app-select>
  </div>
</ng-template>

<ng-template #fecha let-control="control" let-etiqueta="etiqueta" let-span="span">
  <div class="m193d-field" [style.grid-column]="'span ' + (span || 3)">
    <app-date [control]="control" [config]="{ label: etiqueta }"></app-date>
  </div>
</ng-template>

<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>person</mat-icon>
    </div>
    <div class="m193d-header-text">
      <h2 class="cf-dlg-title">{{ titulo }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitulo }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cerrar()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="saving" message="Guardando el perceptor…"></app-loading-state>

  <ng-container *ngIf="!saving && f">
    <div class="cf-dlg-body">

      <div class="m193d-alert" [class.m193d-alert--warning]="item.type === 'WARNING'"
        *ngFor="let item of mensajes(); trackBy: trackByIndex">
        <mat-icon>{{ item.type === 'WARNING' ? 'warning' : 'error' }}</mat-icon>
        <span>{{ item.message }}</span>
      </div>

      <fieldset class="m193d-fs">

        <div class="m193d-box">
          <h6 class="m193d-box__title">Datos del perceptor</h6>
          <div class="m193d-grid">
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifPerceptor', etiqueta: 'NIF del perceptor', requerido: true, max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifRepresentante', etiqueta: 'NIF del representante legal', max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nombre', etiqueta: 'Apellidos y nombre o denominación del perceptor', requerido: true, max: 40, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'provinciaPerceptor', etiqueta: 'Provincia del perceptor', opciones: provinciaOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="sino; context: { ruta: 'mediador', etiqueta: 'Perceptor mediador', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="sino; context: { ruta: 'pendiente', etiqueta: 'Percepción pendiente de cobro', span: 3 }"></ng-container>
          </div>
        </div>

        <div class="m193d-box">
          <h6 class="m193d-box__title">Datos de la percepción</h6>
          <div class="m193d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'clavePercepcion', etiqueta: 'Clave de percepción', opciones: claveOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'naturaleza', etiqueta: 'Naturaleza', opciones: naturalezaOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoPercepcion', etiqueta: 'Tipo de percepción', opciones: tipoPercepcionOptions, requerido: true, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="entero; context: { ruta: 'ejercicioDevengo', etiqueta: 'Ejercicio de devengo', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'ceutaMelillaPalma', etiqueta: 'Ceuta, Melilla o La Palma', opciones: ceutaOptions, span: 6 }"></ng-container>
          </div>
        </div>

        <div class="m193d-box">
          <h6 class="m193d-box__title">Importes</h6>
          <div class="m193d-grid">
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'importePercepciones', etiqueta: 'Importe de las percepciones', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'importeReducciones', etiqueta: 'Importe de reducciones', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'penalizaciones', etiqueta: 'Penalizaciones', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'base', etiqueta: 'Base de la retención', requerido: true, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'porcentaje', etiqueta: '% de retención', span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="importe; context: { ruta: 'retencion', etiqueta: 'Retención e ingreso a cuenta', requerido: true, span: 3 }"></ng-container>
          </div>
        </div>

        <fieldset class="m193d-fs" [disabled]="data.naturalezaDeclarante" *ngIf="esValores">

          <div class="m193d-box">
            <h6 class="m193d-box__title">Identificación de los valores</h6>
            <div class="m193d-grid">
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'pago', etiqueta: 'Pago', opciones: pagoOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'claveMercado', etiqueta: 'Clave de mercado', opciones: claveMercadoOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'claveCodigo', etiqueta: 'Clave código', opciones: claveCodigoOptions, requerido: true, placeholder: 'Seleccionar', span: 6 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'codigoEmisor', etiqueta: 'Código emisor', max: 12, span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'isin', etiqueta: 'Código ISIN', max: 12, span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoCodigo', etiqueta: 'Tipo de código', opciones: tipoCodigoOptions, placeholder: 'Seleccionar', span: 4 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'codigoCuentaValores', etiqueta: esPrestamo ? 'Número de operación del préstamo' : 'Código cuenta valores', max: 20, span: 4 }"></ng-container>
              <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifPagadorAnterior', etiqueta: 'NIF del pagador anterior', max: 9, span: 4 }"></ng-container>
              <ng-container *ngTemplateOutlet="fecha; context: { control: fechaDevengo, etiqueta: 'Fecha de devengo', span: 4 }"></ng-container>
            </div>
          </div>

          <div class="m193d-box" *ngIf="esPrestamo">
            <h6 class="m193d-box__title">Préstamo de valores</h6>
            <div class="m193d-grid">
              <ng-container *ngTemplateOutlet="fecha; context: { control: fechaInicioPrestamo, etiqueta: 'Fecha de inicio del préstamo', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="fecha; context: { control: fechaVencimientoPrestamo, etiqueta: 'Fecha de vencimiento del préstamo', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="importe; context: { ruta: 'compensaciones', etiqueta: 'Compensaciones', span: 3 }"></ng-container>
              <ng-container *ngTemplateOutlet="importe; context: { ruta: 'garantias', etiqueta: 'Garantías', span: 3 }"></ng-container>
            </div>
          </div>

        </fieldset>

        <div class="m193d-box">
          <h6 class="m193d-box__title">Retenciones ingresadas en el Estado, las Diputaciones Forales y la Comunidad Foral de Navarra</h6>
          <div class="m193d-grid">
            <ng-container *ngFor="let foral of rutasForales; trackBy: trackByIndex">
              <ng-container *ngTemplateOutlet="importe; context: { ruta: foral.ruta, etiqueta: foral.etiqueta, span: 4 }"></ng-container>
            </ng-container>
          </div>
        </div>

      </fieldset>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cerrar()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="guardar()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </ng-container>
</div>
